import React from 'react';
import {Backdrop, createStyles, Theme} from "@material-ui/core";
import makeStyles from '@material-ui/core/styles/makeStyles';
import "./index.scss";
import {Button} from "../../Button";
import Timer from "react-compound-timer";
import {strings} from "../../../strings/strings";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1
        }
    })
);

interface Props {
    title: string;
    open: boolean;
    initialTime: number;
    onClick: () => void;
    onTimeEnd: () => void;
}

export const TimerDialog = (props: Props) => {
    const {title, open, initialTime, onClick, onTimeEnd} = props;
    const classes = useStyles();

    return (
        <div>
            <Backdrop open={open} className={classes.backdrop}>
                <div className={"timer-dialog"}>

                    <div className="timer-dialog__title">
                        <span>{title}</span>
                    </div>

                    <div className="timer-dialog__text">
                        <Timer
                            formatValue={(value) => String(value).padStart(2, "0")}
                            initialTime={initialTime}
                            direction="backward"
                            timeToUpdate={999}
                            checkpoints={[
                                {
                                    time: 0,
                                    callback: onTimeEnd,
                                }
                            ]}
                        >
                            {() => (
                                <>
                                    <Timer.Minutes/>:
                                    <Timer.Seconds/>
                                </>
                            )}
                        </Timer>
                    </div>

                    <div className="timer-dialog__btn fluid">
                        <Button label={strings.yes} onClickListener={onClick}/>
                    </div>
                </div>
            </Backdrop>
        </div>
    )
};